import immutableStateInvariant from 'redux-immutable-state-invariant'
import logger from 'redux-logger'
import promise from 'redux-promise-middleware'
import createSagaMiddleware from 'redux-saga'
import { applyMiddleware, createStore, PreloadedState, Reducer, Store } from 'redux'
import { middleware as thunkMiddleware } from 'redux-saga-thunk'
import { composeWithDevTools } from '@redux-devtools/extension';
import { History } from '@dev/history'
import { responsiveStoreEnhancer } from 'redux-responsive'
import { createBrowserHistory, createHashHistory } from '@dev/history'
import { createReduxHistoryContext, RouterState } from "redux-first-history"

/* eslint-disable */

//import { LogRocket, getLogRocketInstance, reduxActionSanitizer, reduxStateSanitizer } from '@dev/ee-tools';



const sagaMiddleware = createSagaMiddleware();
//preventing from mutating store state directly
const imutableStateMiddleware = immutableStateInvariant();

export let history: History;
export let store: Store<any>;

/*if (LOGROCKET_KEY && DEVMODE !== 'DEVELOPMENT' && process.env.NODE_ENV !== 'test') {
    LogRocket(LOGROCKET_KEY, APIPATH);
}*/

export function configureStore<T>(history: History,rootSaga: any, reducers: any, GAKEY?: string, DEVMODE?: string): { store: Store<T>, history: History} {
    const composeEnhancers = composeWithDevTools({});

    const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
        history,
        savePreviousLocations: 1
    });

    let middleware = [promise, thunkMiddleware, sagaMiddleware, routerMiddleware];
    

    /*if (LOGROCKET_KEY && DEVMODE !== 'DEVELOPMENT') {
        middleware.push(
            getLogRocketInstance().reduxMiddleware({
                actionSanitizer: reduxActionSanitizer,
                stateSanitizer: reduxStateSanitizer,
            })
        );
    }*/

    if (DEVMODE === 'DEVELOPMENT') {
        middleware = [...middleware, imutableStateMiddleware, logger];
    }

    const store: Store<T> = createStore(
        reducers(routerReducer),
        {} as PreloadedState<T>,
        composeEnhancers(responsiveStoreEnhancer, applyMiddleware(...middleware))
    );

    sagaMiddleware.run(rootSaga);

    const reduxHistory = createReduxHistory(store);

    return { store, history: reduxHistory };
}
export default store;

interface BootInterface<T> {
    basename?: string,
    isStandAlone: boolean;
    rootSaga: any;
    reducers(routerReducer: Reducer<RouterState>): Reducer<T>;
    GAKEY?: string;
    DEVMODE?: string;
}

export function boot<T extends {}>({basename, isStandAlone, rootSaga, reducers, GAKEY, DEVMODE}: BootInterface<T>): { history: History; store: Store<T> } {
    if (store) {
        return { store, history }
    }

    const historyObject = isStandAlone ? createBrowserHistory({ basename }) : createHashHistory();

    const { store: newStore, history: newHistory } = configureStore<T>(historyObject, rootSaga, reducers, GAKEY, DEVMODE);

    store = newStore;
    history = newHistory;
    return { history, store };
}
